if (!customElements.get('a20-editorial')) {
  customElements.define('a20-editorial', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const animate = !reduceMotion.matches && this.dataset.motion !== 'false';
      if (animate && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('a20-enter');
            this.observer.unobserve(entry.target);
          });
        }, { threshold: 0.18 });
        this.querySelectorAll('[data-a20-reveal]').forEach(el => this.observer.observe(el));
      }
      const track = this.querySelector('[data-a20-track]');
      if (!track) return;
      const items = Array.from(track.children);
      const prev = this.querySelector('[data-a20-prev]');
      const next = this.querySelector('[data-a20-next]');
      const counter = this.querySelector('[data-a20-counter]');
      const progress = this.querySelector('[data-a20-progress]');
      const update = () => {
        this.frame = 0;
        const x = track.getBoundingClientRect().left;
        let index = 0;
        let nearest = Infinity;
        items.forEach((item, i) => {
          const distance = Math.abs(item.getBoundingClientRect().left - x);
          if (distance < nearest) { nearest = distance; index = i; }
        });
        this.index = index;
        if (counter) counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(items.length).padStart(2, '0')}`;
        if (progress) progress.style.width = `${(index + 1) / items.length * 100}%`;
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === items.length - 1;
      };
      const move = step => {
        const index = Math.max(0, Math.min(items.length - 1, (this.index || 0) + step));
        const target = items[index];
        track.scrollBy({left: target.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: reduceMotion.matches ? 'instant' : 'smooth'});
      };
      prev?.addEventListener('click', () => move(-1), {signal});
      next?.addEventListener('click', () => move(1), {signal});
      track.addEventListener('scroll', () => {
        if (!this.frame) this.frame = requestAnimationFrame(update);
      }, {passive:true, signal});
      track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }, {signal});
      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(update);
        this.resize.observe(track);
      }
      this.classList.add('a20-ready');
      update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
